import { Device, Subscription } from 'react-native-ble-plx';

export const BT_GATT_UUIDS = {
  SERVICE_AKIN_CONNECT: '603a6999-199b-418b-b38e-3412af25ae42',
  CHAR_ROBOT_ID: '6487789a-50e5-4520-84e5-cc6919855773',
  CHAR_SSID: '24c486b2-ff1f-4606-ab6c-2d82f96600ea',
  CHAR_PASSWORD: 'f30fcada-6d25-4b14-a6cc-f4f161887a61',
  CHAR_IP_ADDR: 'afcc6fd5-0c99-4aeb-b89c-81dce8273191',
  CHAR_ERROR: 'c1b7d810-5776-45f9-ade1-279f17c6bdfc',
} as const;

export type BluetoothConnectionStatus =
  | 'disconnected'
  | 'connecting'
  | 'connected'
  | 'disconnecting';

export type RobotBluetoothConnection = {
  connectionStatus: BluetoothConnectionStatus;
  bluetoothDevice?: Device | undefined;
  macAddress?: string;
  onDisconnectSub?: Subscription;
};
